export default __webpack_public_path__ + "static/media/coreCard6.8955f077.svg";